import { Box, SvgIconTypeMap } from "@mui/material";
import { FC } from "react";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import { OverridableComponent } from "@mui/material/OverridableComponent";

type ImgProps = {
  src?: string;
  width: number;
  height: number;
  circle?: boolean;
  icon?: OverridableComponent<SvgIconTypeMap<{}, "svg">> | null;
};

export const Img: FC<ImgProps> = ({
  src,
  width,
  height,
  circle,
  icon = null,
}) => {
  const BaseIcon = icon ? icon : InsertPhotoIcon;

  return (
    <Box
      sx={{
        width: `${width}px`,
        height: `${height}px`,
        border: src ? "none" : "1px solid rgba(0, 0, 0, 0.3)",
        borderRadius: circle ? "50%" : "0",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {src ? (
        <img
          src={src}
          alt="circle avatar"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : (
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "100%",
          }}
        >
          <BaseIcon
            fontSize="large"
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};
